// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__RNVUC","consentsList":"PatientConsents_consentsList__2PygA","consentsListEmpty":"PatientConsents_consentsListEmpty__fFeIk"};